import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import LoaderFull from './LoaderFull';

const AdminRoute = ({ children }: { children: JSX.Element }) => {
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null); // Gebruik null om de laadtoestand aan te geven

  useEffect(() => {
    // const accessToken = localStorage.getItem('accesstoken');
    // const refreshToken = localStorage.getItem('refreshtoken');
    const localStorageUser = localStorage.getItem('bibloUser');
    const user = JSON.parse(localStorageUser || '{}');
   

    // Verifieer de access token met een API-aanroep
    const checkRole = async () => {
        // TODO: maybe validate in backend later on
        if (user.role === 'ADMIN') {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
        }
    };

    checkRole();
  }, []);

  // Wacht tot de status is bepaald
  if (isAdmin === null) {
    return <LoaderFull />; // Of een andere laadindicator
  }

  return isAdmin ? children : <Navigate to="/" />;
};

export default AdminRoute;
